export var FETCH_URL_TIMEOUT = 3000;
export var FETCH_URL_TIMEOUT_RESULT = 'FETCH_URL_TIMEOUT_RESULT';